module.exports = __webpack_public_path__ + "src/assets/img/trank_open_light_front.cad9f0e9.svg";